<template>
    <keep-alive>
    <div class="conrainer">
        <BigScreenHead>
          <template v-slot:center >
              <div class="head-title">收 款 管 理 板 块</div>
          </template>
        </BigScreenHead>
        <main>
            <div class="info">
                <div class="chart">
                    <div class="chartitle">按揭中设备总数（台）</div>
                    <div class="chart1"></div>
                </div>
                <div class="chart">
                    <div class="chartitle">本月已还款（台）</div>
                    <div class="chart2"></div>
                </div>
                <div class="chart">
                    <div class="chartitle">本月尚未还款（台）</div>
                    <div class="chart3"></div>
                </div>
                <div class="chart">
                    <div class="chartitle">本月已超期（台）</div>
                    <div class="chart4"></div>
                </div>
                <div class="loudoubox">
                    <div class="chartitle">超期设备各销售公司分摊</div>
                    <div class="chart5"></div>
                </div>
                <div class="toptitle">
                    <p>超</p>
                    <p>期</p>
                    <p>客</p>
                    <p>户</p>
                    <p>名</p>
                    <p>单</p>
                </div>
                <ul class="info-ul">
                    <li v-for="(item,i) in companyList" :key="i">
                        <div :style="{color:i==0?'#EDB941':i==1?'#40b337':i==2?'#7194F3':'#fff'}">TOP {{i+1}}</div>
                        <div class="title" v-overflow>{{item.name}}</div>
                        <div style="color:#bf0000">{{item.number}}台</div>
                        <div style="color:#bf0000">占{{item.percent}}%</div>
                    </li>

                </ul>
            </div>
            <div class="searchbox">
                <el-input v-model="loanDataForm.filter" placeholder="输入产品型号/出厂编号"></el-input>
                <el-input v-model="loanDataForm.companyName" placeholder="输入客户公司名称"></el-input>
                <el-input v-model="loanDataForm.contractNo" placeholder="输入合同号"></el-input>
                <el-date-picker
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    start-placeholder="发货日期 (起始)"
                    end-placeholder="发货日期 (截止)">
                </el-date-picker>
                    <el-select v-model="loanDataForm.lockState" placeholder="锁机状态" class="my-select">
                    <el-option :value = -1 label="锁机状态"></el-option>
                    <el-option :value = 0 label="未锁机"></el-option>
                    <el-option :value = 1 label="已锁机"></el-option>
                </el-select>
                    <el-select v-model="loanDataForm.loanState" placeholder="本月还款状态" class="my-select">
                    <el-option :value = -1 label="本月还款状态"></el-option>
                    <el-option :value = 0 label="已还款"></el-option>
                    <el-option :value = 1 label="未还款"></el-option>
                </el-select>
                <div class="btn-box">
                    <el-button type="primary" @click="search">查 询</el-button>
                    <el-button @click="reset">重 置</el-button>
                    <!-- <el-button @click="reset" type="primary" :loading="true" style="width: 95px;">导出Excel</el-button> -->
                    <download-excel
                        class="export-excel-wrapper"
                        :data="json_data"
                        :fields="json_fields"
                        name="收款信息导出.xls">
                        <button type="primary" size="small">导出excel</button>
                    </download-excel>
                </div>
            </div>
            <div class="tablebox">
                <table>
                    <tr>
                        <td style="width:3%"></td>
                        <td>产品型号</td>
                        <td>出厂编号</td>
                        <td style="width:4%">截面</td>
                        <td>客户公司名称</td>
                        <td>合同号</td>
                        <td>销售公司</td>
                        <td style="width:5%">销售员</td>
                        <td>发货日期</td>
                        <td>设备地点</td>
                        <td style="width:5%">联网状态</td>
                        <td>本月还款状态</td>
                        <td>历史超期次数</td>
                        <td>历史未还款数</td>
                        <td style="width:5%">锁机状态</td>
                        <td  v-if="user.systemRole==1 || user.systemRole==2 || user.systemRole==3">操作</td>
                        <td style="width:7%">设备运行实况</td>
                    </tr>
                    <tr v-for="(item,i) in loanDataList" :key="item.id">
                        <td>{{i+1}}</td>
                        <td v-overflow>{{item.modelName}}</td>
                        <td v-overflow>{{item.factorNo}}</td>
                        <td v-overflow>{{item.section}}</td>
                        <td v-overflow>{{item.customerName}}</td>
                        <td v-overflow>{{item.contractNo}}</td>
                        <td v-overflow>{{item.salesCompanyName}}</td>
                        <td v-overflow>{{item.salesPerson}}</td>
                        <td v-overflow>{{item.sendDate | timeFomart}}</td>
                        <td v-overflow>{{item.sendAddress}}</td>
                        <td :style="{color:item.onlineColor}">{{item.onlineText}}</td>
                        <td :style="{color:item.LoanColor}">{{item.LoanText}}</td>
                        <td v-overflow :style="{color:item.hisOverdue!=0?'#bf0000':''}">{{item.hisOverdue}}</td>
                        <td v-overflow :style="{color:item.hisUndue!=0?'#bf0000':''}">{{item.hisUndue}}</td>
                        <td :style="{color:item.lockColor}">{{item.lockText}}</td>
                        <td v-if="user.systemRole==1 || user.systemRole==2 || user.systemRole==3"><el-button v-if="item.id" :class="item.lockState==0?'suoji-btn':'jiesuo-btn'" @click="lock(item)">{{item.lockState==0?'远程锁机':'远程解锁'}}</el-button></td>
                        <td >
                            <el-button v-if="item.id && item.type==1" class="chakan-btn" @click="toDevice(item,1)">查 看</el-button>
                            <el-button v-if="item.id && item.type==2" :disabled="!item.imei" :style="{background:!item.imei && '#ccc'}" class="chakan-btn" @click="toDevice(item,1)">左 笼</el-button>
                            <el-button v-if="item.id && item.type==2" :disabled="!item.rightImei" :style="{marginLeft:'7%',background:!item.rightImei && '#ccc'}" class="chakan-btn" @click="toDevice(item,2)">右 笼</el-button>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="page">
                <div @click="prev" >上一页</div>
                <div style="margin:0 2%;">第{{loanDataForm.pageIndex}}页 共{{loanDataTotal}}条</div>
                <div @click="next">下一页</div>
            </div>
            <el-dialog width="25%" center :visible.sync="dialogShow" style="margin-top: 10%;">
                <template slot="title">
                    <div style="color: #bf0000;font-size:20px">重要提示</div>
                </template>
                <div class="dialog" >
                    <div class="dialog-content" v-if="lockStatus==0"><span style="margin-left:35px;">该</span>操作将会锁止起重设备，会导致设备运行速度减半甚至关停，影响重大，请审慎操作！</div>
                    <div class="dialog-content" v-if="lockStatus==1"><span style="margin-left:35px;">该</span>操作将会解锁起重设备，使设备恢复正常使用，请确认您的操作！</div>
                    <div class="dialog-footer">
                        <button class="dialog-btn" :style="{background:lockStatus==0?'#bf0000':'#40b337'}" @click="confirm">{{lockStatus==0?'确认锁机':'确认解锁'}}</button>
                        <button class="dialog-btn btn2" @click="dialogShow = false">放弃操作</button>
                    </div>
                </div>
            </el-dialog>
        </main>
    </div>
    </keep-alive>
</template>

<script>
import { shoukuanPie,shoukuanLoudou } from '../assets/js/echarts'
export default {
    data(){
        return{
            time: [],
            dialogShow: false,
            companyList: [],
            loanDataForm:{
                filter:"",
                companyName:"",
                contractNo:"",
                starTime:'',
                endTime:'',
                lockState:-1,
                loanState:-1,
                pageSize:15,
                pageIndex:1
            },
            loanDataTotal:0,
            loanDataList:[],
            json_fields: {
                "产品型号": "modelName",
                "出厂编号": "factorNo",
                "截面": "section",
                "客户公司名称": "customerName",
                "合同号": "contractNo",
                "销售公司": "salesCompanyName",
                "销售员": "salesPerson",
                "发货日期": "sendDate",
                "设备地点": "sendAddress",
                "联网状态": "onlineText",
                "本月还款状态": "LoanText",
                "历史超期次数": "hisOverdue",
                "历史未还款数": "hisUndue",
                "锁机状态": "lockText",
            },
            json_data: [],
            imei:'',
            lockStatus:'',
            user:{},
        }
    },
    methods:{
        getLoanPieInfo(){
            this.$api.LoanPieChartInfo().then(res=>{
                var value = res.data.data;
                shoukuanPie({doc:'.chart1',type:1,data:[{ name:'塔机',value:value.mortgageTower },{ name:'升降机',value:value.mortgageLifter }],text:value.mortgageTotal});
                shoukuanPie({doc:'.chart2',type:2,data:[{ name:'塔机',value:value.repaymentTower },{ name:'升降机',value:value.repaymentLifter }],text:value.repaymentTotal});
                shoukuanPie({doc:'.chart3',type:3,data:[{ name:'塔机',value:value.outstandingTower },{ name:'升降机',value:value.outstandingLifter }],text:value.outstandingTotal});
                shoukuanPie({doc:'.chart4',type:4,data:[{ name:'塔机',value:value.overdueTower },{ name:'升降机',value:value.overdueLifter }],text:value.overdueTotal});                  
            })
        },
        getLoanCompanyInfo(){
            this.$api.LoanCompanyInfo().then(res=>{
                var salesList = res.data.data.salesList;
                var customerList = res.data.data.customerList;
                var chartData = [];
                if(customerList.length < 5){
                    for(let i=customerList.length; i<5; i++){
                        var temp = {
                            name: "暂无",
                            number: 0,
                            percent: 0
                        };
                        customerList.push(temp);
                    }
                }
                if(customerList.length > 5){
                    customerList = customerList.slice(0,5)
                }
                this.companyList = customerList;
                if(salesList.length < 5){
                    for(let i=salesList.length; i<5; i++){
                        salesList.push({
                            name: '',
                            value: '',
                            reveal: '',
                            number: 0,
                            reveal:0,
                            percent: 0,
                        });
                    }
                }
                if(salesList.length > 5){
                    salesList = salesList.slice(0,5)
                }
                salesList.map((item,i)=>{
                    if(item.number == 0){
                        chartData.push({
                            name: '暂无'+i,
                            value: 10*(i+1),
                            reveal: item.percent,
                            number: 0
                        });
                    }else{
                        chartData.push({
                            name: item.name,
                            value: 10*(i+1),
                            reveal: item.percent,
                            number: item.number
                        });
                    }
                })
                shoukuanLoudou({doc:'.chart5',data:chartData})
            })
        },
        //获取表格数据
        getLoanDataListInfo(){
            if(this.time == null || this.time.length <= 0){                
                var EndTime = new Date();
                var NowTime = new Date();
                EndTime.setTime(EndTime.getTime());
                // NowTime.setTime(NowTime.getTime() - 3600 * 1000 * 24 * 15);
                NowTime.setFullYear('2021','00','01');
                this.time = ["",""];
                this.time[0] = NowTime;
                this.time[1] = EndTime;
            }
            this.loanDataForm.starTime = this.time[0];
            this.loanDataForm.endTime = this.time[1];
            this.$api.LoanDataListInfo(this.loanDataForm).then(res=>{
                var list = res.data.data.data;
                this.loanDataTotal = res.data.data.total;
                list.map(item => {
                    if(item.onlineState == 0){
                        item.onlineText = '离线'
                        item.onlineColor = '#bf0000'
                    }else if(item.onlineState == 1){
                        item.onlineText = '在线'
                        item.onlineColor = '#40b337'
                    }else{
                        item.onlineText = '信号差'
                        item.onlineColor = '#7194F3'
                    }
                    if(item.lockState == 0){
                        item.lockText = '未锁机'
                        item.lockColor = '#40b337'
                    }else{
                        item.lockText = '已锁机'
                        item.lockColor = '#bf0000'
                    }
                    if(item.monthLoanState == 0){
                        item.LoanText = '未还款'
                        item.LoanColor = '#bf0000'
                    }else if(item.monthLoanState == 1){
                        item.LoanText = '已超期'
                        item.LoanColor = '#bf0000'
                    }else if(item.monthLoanState == 2){
                        item.LoanText = '超期还款'
                        item.LoanColor = '#EDB941'
                    }else{
                        item.LoanText = '已还款'
                        item.LoanColor = '#40b337'
                    };
                });
                if(list.length < 15){
                    for(let i=list.length; i<15; i++){
                        list.push({});
                    }
                }
                this.loanDataList = list;
            })
        },
        //获取表格所有数据（不分页）
        getTotalList(){
            if(this.time == null || this.time.length <= 0){                
                var EndTime = new Date();
                var NowTime = new Date();
                EndTime.setTime(EndTime.getTime());
                // NowTime.setTime(NowTime.getTime() - 3600 * 1000 * 24 * 15);
                NowTime.setFullYear('2021','00','01');
                this.time = ["",""];
                this.time[0] = NowTime;
                this.time[1] = EndTime;
            }
            this.loanDataForm.starTime = this.time[0];
            this.loanDataForm.endTime = this.time[1];
            this.$api.LoanDataListInfo({
                ...this.loanDataForm,
                pageSize:100000,
                pageIndex:1
            }).then(res=>{
                var list = res.data.data.data;
                this.json_data = [];
                list.map(item => {
                    if(item.onlineState == 0){
                        item.onlineText = '离线'
                        item.onlineColor = '#bf0000'
                    }else if(item.onlineState == 1){
                        item.onlineText = '在线'
                        item.onlineColor = '#40b337'
                    }else{
                        item.onlineText = '信号差'
                        item.onlineColor = '#7194F3'
                    }
                    if(item.lockState == 0){
                        item.lockText = '未锁机'
                        item.lockColor = '#40b337'
                    }else{
                        item.lockText = '已锁机'
                        item.lockColor = '#bf0000'
                    }
                    if(item.monthLoanState == 0){
                        item.LoanText = '未还款'
                        item.LoanColor = '#bf0000'
                    }else if(item.monthLoanState == 1){
                        item.LoanText = '已超期'
                        item.LoanColor = '#bf0000'
                    }else if(item.monthLoanState == 2){
                        item.LoanText = '超期还款'
                        item.LoanColor = '#EDB941'
                    }else{
                        item.LoanText = '已还款'
                        item.LoanColor = '#40b337'
                    };
                    this.json_data.push({
                        modelName: item.modelName,
                        factorNo: item.factorNo,
                        section: item.section,
                        customerName: item.customerName,
                        contractNo: item.contractNo,
                        salesCompanyName: item.salesCompanyName,
                        salesPerson: item.salesPerson,
                        sendDate: item.sendDate && item.sendDate.slice(0,10),
                        sendAddress: item.sendAddress,
                        onlineText: item.onlineText,
                        LoanText: item.LoanText,
                        hisOverdue: item.hisOverdue,
                        hisUndue: item.hisUndue,
                        lockText: item.lockText,
                    })
                });
            })
        },
        search(){
            this.loanDataForm.pageSize = 15;
            this.loanDataForm.pageIndex = 1;
            this.getLoanDataListInfo();
            this.getTotalList();
        },
        reset(){
            this.loanDataForm.filter = "";
            this.loanDataForm.companyName = "";
            this.loanDataForm.contractNo = "";
            this.loanDataForm.pageIndex = 1;
            this.loanDataForm.pageSize = 15;
            this.loanDataForm.lockState = -1;    
            this.loanDataForm.loanState = -1;           
            this.time = [];
            this.getLoanDataListInfo();
        },
        //跳转至设备页面
        toDevice(item,p){
            if(item.type==1){
                this.$router.push('/TowerBigScreen?imei='+item.imei)
            }else{
                if(p == 1){
                    this.$router.push('/LifterBigScreen?imei='+item.imei + '&cagecate=' + 1)
                }else{
                    this.$router.push('/LifterBigScreen?imei='+item.rightImei + '&cagecate=' + 2)
                }
            }
        },
        //点击锁机按钮
        lock(item){
            this.imei = item.imei || item.rightImei;
            this.lockStatus = item.lockState;
            this.dialogShow = true;
            if(item.lockState == 0){

            }
        },
        //锁机按钮确定
        confirm(){
            this.$api.DeviceLock({imei:this.imei}).then(res=>{
                if(res.data.code == 200){
                    this.$message({
                        showClose: true,
                        message: res.data.msg,
                        type: 'success'
                    });
                }else{
                    this.$message({
                        showClose: true,
                        message: res.data.msg,
                        type: 'error'
                    });
                }
                this.getLoanDataListInfo();
                this.dialogShow = false;
            })
        },
        //上一页
        prev(){
            if (this.loanDataForm.pageIndex <= 1) return;
            this.loanDataForm.pageIndex --;
            this.getLoanDataListInfo();
        },
        //下一页
        next(){
            var listLength = this.loanDataForm.pageIndex * this.loanDataForm.pageSize;
            if(this.loanDataTotal <= listLength) return;
            this.loanDataForm.pageIndex ++;
            this.getLoanDataListInfo();
        }
    },
    created(){
        this.user = JSON.parse(localStorage.getItem('user'))
    },
    mounted(){
        this.getLoanPieInfo();
        this.getLoanCompanyInfo();
        this.getLoanDataListInfo();
        this.getTotalList();
    },
}
</script>

<style lang="scss" scoped>
.conrainer{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url('../assets/images/bigScreen_back.webp') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 0 1rem;
}
.head-title{
    font-size: 1.5625rem;
    font-weight: bold;
    letter-spacing: 5px;
}
main{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .dialog{
        width: 100%;
        height: 10rem;
        margin: auto;        
        background: #fff;
        border-radius: 6px;
        align-items: center;
        .dialog-content{
            color: #000;
            line-height: 1.5625rem;
            width: 80%;
            margin-left: 10%;
            letter-spacing: 1px;
            flex: 1;
            font-size: 1.0625rem;
        }
        .dialog-footer{
            font-weight: 600;
            height: 40%;
            width: 80%;
            margin-left: 10%;
            margin-top: 5%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            .dialog-btn{
                width: 29%;
                height: 1.9rem;
                color: #fff;
                background: #bf0000;
                line-height: 0;
                border-radius: 5px;
                cursor: pointer;
            }
            .btn2{
                background: #B3B3B3
            }
            .dialog-btn:active{background: rgba($color: #bf0000, $alpha: 0.9);}
            .btn2:active{background: rgba($color: #B3B3B3, $alpha: 0.9);}
        }
    }
}
.info{
    height: 22.5%;
    display: flex;
    .chart{
        width: 12%;
        display: flex;
        flex-direction: column;
    }
    .chart1,.chart2,.chart3,.chart4,.chart5{
        flex: 1;
    }
    .chartitle{
        height: 18%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        font-weight: bold;
        letter-spacing: 1px;
    }
    .loudoubox{
        width: 22%;
        display: flex;
        flex-direction: column;
    }
    .toptitle{
        width: 3%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 1.0625rem;
    }
    .info-ul{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        li{
            display: flex;
            padding-right: 10%;
            :nth-child(2){
                flex: 1;
                margin: 0 1rem;
            }
            :nth-child(3){
                width: 3.75rem;
                color:#bf0000;
            }
            :nth-child(4){
                width: 3.75rem;
                color:#bf0000;
            }
        }
    }
}
.searchbox{
    height: 6%;
    display: flex;
    align-items: center;
}
.btn-box{
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .el-button{
        height: 60% !important;
        width: 3.75rem;
        padding: 0;
        line-height: 0;
        background: #EDB941;
        color: #fff;
        border: none;
        margin-left: 0.9375rem;
    }
    .el-button:active{
        background: rgba($color: #EDB941, $alpha: 0.9);
    }
}
.tablebox{
    flex: 1;
    table{
        height: 100%;
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        overflow: hidden;
        td{
            border: 1px solid #fff;
            text-align: center;
            font-size: 0.9375rem;
            padding: 0 3px;
        }
        .el-button{
            height: 60%;
            width: 55%;
            margin: 0;
            padding: 0;
            color: #fff;
            border: none;
            font-size: 0.8rem;
            line-height: 1.375rem;
            position: relative;
        }
        .suoji-btn{
            background: #bf0000;
            width: 60%;
        }
        .suoji-btn:active{background: rgba($color: #bf0000, $alpha: 0.8);}
        .jiesuo-btn{
            background: #40b337;
            width: 60%;
        }
        .jiesuo-btn:active{background: rgba($color: #40b337, $alpha: 0.8);}
        .chakan-btn{
            background: #EDB941;
            width: 40%;
        }
        .chakan-btn:active{background: rgba($color: #EDB941, $alpha: 0.8);}
    }
}
.page{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 7%;
    font-weight:bold;
    font-size: 0.9375rem;
    & div{ cursor: pointer;}
    & div:active{ color: #EDB941;}
}
.export-excel-wrapper{
    margin: 0 15px;
    height: 58% !important;
    button{
        color: #fff;
        background: #EDB941;
        height: 100% !important;
        width: 5.3125rem;
        border-radius: 5px;
        cursor: pointer;
        font-size: 0.9375rem;
    }
    button:active{background: rgba($color: #EDB941, $alpha: 0.8);}
}
</style>